import { FormInput } from "@general-backoffice/core";
import type { TaxProfile } from "@investhinks/api-client";
import React from "react";
import { Alert } from "reactstrap";

type CompanyInfoStepTaxProfile = Pick<TaxProfile, "viesVerified" | "viesName" | "name" | "fiscalAddress"> & Record<string, unknown>;

interface CompanyInfoStepProps {
  taxProfile: CompanyInfoStepTaxProfile | null;
  handleInputEvent: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isLoading: boolean;
  t: (key: string, fallback?: string) => string;
}

const CompanyInfoStep = ({ taxProfile, handleInputEvent, isLoading, t }: CompanyInfoStepProps) => {
  // Check if data was pre-filled from VIES
  const prefilledFromVIES = taxProfile?.viesVerified && taxProfile?.viesName;

  return (
    <div>
      <h5 className="mb-3">{t("steps.companyInfo.title", "Company Information")}</h5>
      <p className="text-muted mb-4">{t("steps.companyInfo.description", "Please provide your company details.")}</p>

      {prefilledFromVIES && (
        <Alert color="info" className="mb-3">
          <i className="fas fa-info-circle mr-2" />
          {t(
            "steps.companyInfo.prefilledFromVIES",
            "Company details have been pre-filled from VIES verification. Please review and edit if needed."
          )}
        </Alert>
      )}

      <FormInput.Input
        type="text"
        onChange={handleInputEvent}
        value={taxProfile?.name || ""}
        name="name"
        label={t("steps.companyInfo.nameLabel", "Company Name")}
        disabled={isLoading}
      />

      <FormInput.Input
        type="textarea"
        rows={3}
        onChange={handleInputEvent}
        value={taxProfile?.fiscalAddress || ""}
        name="fiscalAddress"
        label={t("steps.companyInfo.addressLabel", "Fiscal Address")}
        disabled={isLoading}
      />
    </div>
  );
};

export default CompanyInfoStep;
